import { useState } from "react";
import { Loader2 } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { CategoryPicker } from "@/components/shared/category-picker";

export function RecategorizeDialog({
  open,
  onOpenChange,
  count,
  categories,
  loading = false,
  onConfirm,
  onCreateCategory,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  count: number;
  categories: { id: string; name: string }[];
  loading?: boolean;
  onConfirm: (categoryName: string) => void;
  onCreateCategory?: (name: string) => void;
}) {
  const [value, setValue] = useState<string>("");

  const handleOpenChange = (next: boolean) => {
    if (!next) setValue("");
    onOpenChange(next);
  };

  const disabled = loading || !value;

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle>
            Recategorize {count} receipt{count === 1 ? "" : "s"}
          </DialogTitle>
          <DialogDescription>
            Pick a category to apply to every selected receipt. Existing
            categories on those receipts will be overwritten.
          </DialogDescription>
        </DialogHeader>
        <div className="py-2">
          <CategoryPicker
            value={value}
            onChange={setValue}
            categories={categories}
            onCreateCategory={onCreateCategory}
            ariaLabel="Pick a category to apply"
          />
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => handleOpenChange(false)}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            onClick={() => value && onConfirm(value)}
            disabled={disabled}
          >
            {loading && <Loader2 className="mr-1.5 size-4 animate-spin" />}
            Recategorize
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
